import { render } from "./EditorialBoardView.vue?vue&type=template&id=75c01644"
import script from "./EditorialBoardView.vue?vue&type=script&lang=js"
export * from "./EditorialBoardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__